import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  activitiesThisMonth: "Activities This Month",
  activitiesSubtitle: "Meetings, calls, notes, flows",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    activitiesThisMonth: "Activités ce mois-ci",
    activitiesSubtitle: "Rendez-vous, appels, notes, parcours",
  },
  es_ES: {
    activitiesThisMonth: "Actividades este mes",
    activitiesSubtitle: "Reuniones, llamadas, notas, flujos",
  },
  pt_BR: {
    activitiesThisMonth: "Atividades este mês",
    activitiesSubtitle: "Reuniões, ligações, notas, fluxos",
  },
  de_DE: {
    activitiesThisMonth: "Aktivitäten diesen Monat",
    activitiesSubtitle: "Termine, Anrufe, Notizen, Flows",
  },
  it_IT: {
    activitiesThisMonth: "Attività di questo mese",
    activitiesSubtitle: "Riunioni, chiamate, note, flussi",
  },
  ar: {
    activitiesThisMonth: "أنشطة هذا الشهر",
    activitiesSubtitle: "اجتماعات، مكالمات، ملاحظات، مسارات",
  },
  ja_JP: {
    activitiesThisMonth: "今月のアクティビティ",
    activitiesSubtitle: "面談、通話、メモ、フロー",
  },
  hi_IN: {
    activitiesThisMonth: "इस माह की गतिविधियाँ",
    activitiesSubtitle: "मीटिंग, कॉल, नोट्स, फ़्लो",
  },
  zh_CN: {
    activitiesThisMonth: "本月活动",
    activitiesSubtitle: "会议、通话、备注、流程",
  },
  zh_TW: {
    activitiesThisMonth: "本月活動",
    activitiesSubtitle: "會議、通話、備註、流程",
  },
  nl_NL: {
    activitiesThisMonth: "Activiteiten deze maand",
    activitiesSubtitle: "Afspraken, gesprekken, notities, flows",
  },
  nb_NO: {
    activitiesThisMonth: "Aktiviteter denne måneden",
    activitiesSubtitle: "Møter, samtaler, notater, flyter",
  },
  sv_SE: {
    activitiesThisMonth: "Aktiviteter denna månad",
    activitiesSubtitle: "Möten, samtal, anteckningar, flöden",
  },
  fi_FI: {
    activitiesThisMonth: "Toiminnot tässä kuussa",
    activitiesSubtitle: "Tapaamiset, puhelut, muistiinpanot, prosessit",
  },
  da_DK: {
    activitiesThisMonth: "Aktiviteter denne måned",
    activitiesSubtitle: "Møder, opkald, noter, forløb",
  },
  is_IS: {
    activitiesThisMonth: "Aðgerðir í þessum mánuði",
    activitiesSubtitle: "Fundir, símtöl, minnispunktar, ferli",
  },
};
